import React from 'react';

import PageContent from 'components/PageContent';
import CurrencyExchangeTable from 'components/CurrencyExchangeTable';
import CurrencyTable from 'components/CurrencyTable';
import CurrencyConverter from 'components/CurrencyConverter';
import BanksTable from 'components/BanksTable';
import CurrencyNews from 'components/CurrencyNews';
import { CurrencyAverageTable } from 'components/CurrencyAverageTable';
import ExchangeDiscussion from 'components/ExchangeDiscussion';
import NewsSlider from 'components/NewsSlider';
import Banner from 'components/Banner';
import EmblaCarousel from 'components/EmblaCarousel/loadableEmblaCarousel';
import { NUMBER_OFF_ALL_ORGANIZATIONS } from 'constants/organizations';

const HomePageContent = () => {
  return (
    <PageContent>
      <CurrencyAverageTable />
      <Banner id="hp-react-banner-content-1" slot="bn-slot-content-1" />
      <BanksTable quantity={NUMBER_OFF_ALL_ORGANIZATIONS} />
      <Banner id="hp-react-banner-content-2" slot="bn-slot-content-2" />
      <CurrencyConverter page="homepage" />
      <CurrencyExchangeTable />
      <CurrencyTable />
      <ExchangeDiscussion />
      <NewsSlider />
      <CurrencyNews />
      <EmblaCarousel />
    </PageContent>
  );
};

export default HomePageContent;
